// extracted by mini-css-extract-plugin
module.exports = {"bundleCard":"BundleCard--bundle-card--jaKkZ"};